var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenScoreE(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 130,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.001 109.318C.001 120.723 9.682 130 21.579 130h196.85c11.894 0 21.573-9.28 21.573-20.682V20.681C240.002 9.277 230.322 0 218.428 0H21.577C9.682 0 0 9.279 0 20.68Z",
    style: {
      strokeWidth: 1.636
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d93726",
    fillRule: "evenodd",
    d: "M2.35 109.318c0 10.017 8.535 18.334 19.229 18.334h196.85c10.693 0 19.227-8.32 19.227-18.334V20.681c0-10.016-8.534-18.333-19.228-18.333H21.577c-10.694 0-19.228 8.32-19.228 18.333zM21.578 130C9.684 130 0 120.723 0 109.318V20.681C.001 9.28 9.68 0 21.577 0h196.851c11.895 0 21.574 9.277 21.574 20.681v88.64c0 11.402-9.68 20.681-21.574 20.681z",
    clipRule: "evenodd",
    style: {
      strokeWidth: 1.636
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d93726",
    d: "M101.452 19.472c1.592-.132 3.068 1.34 2.931 2.93-.196 2.265-3.014 53.748-19.492 70.224-15.792 15.79-34.397 12.087-46.548 3.35a13.39 13.39 0 0 1-.492-.375l-10.95 10.937a6.777 6.777 0 0 1-9.583-9.584l10.94-10.95a12.965 12.965 0 0 1-.379-.495c-8.732-12.148-12.44-30.755 3.35-46.547 16.471-16.478 67.957-19.298 70.223-19.49Z",
    style: {
      strokeWidth: 1.636
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M71.057 82.016c2.24 0 3.696-1.269 3.696-3.372 0-2.105-1.483-3.372-3.696-3.372h-14.43v-9.82h13.73c2.05 0 3.398-1.185 3.398-3.127 0-1.942-1.374-3.13-3.398-3.13h-13.73v-9.358h14.432c2.21 0 3.694-1.269 3.694-3.372 0-2.105-1.457-3.372-3.696-3.372H52.555c-2.564 0-4.074 1.565-4.074 4.235v30.425c0 2.698 1.51 4.263 4.074 4.263z",
    style: {
      strokeWidth: 1.636
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(99.997 -97.489) scale(.9273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.537 129.227v24.909c0 6.227-3.8 9.963-10.135 9.963-5.068 0-7.601-3.736-7.601-3.736v-6.227s3.8 4.981 7.601 4.981c3.8 0 5.068-2.491 5.068-4.981v-3.089c-1.42.299-3.244.598-5.068.598-6.334 0-11.402-4.982-11.402-11.209 0-6.227 5.068-11.209 11.402-11.209zm-10.135 17.436c1.368 0 3.446-.349 5.068-.697v-11.757h-5.068c-3.8 0-6.334 2.491-6.334 6.227s2.533 6.227 6.334 6.227zM45.166 139.191c0-6.228 3.8-9.964 10.135-9.964v4.982c-5.068 0-10.135 1.245-10.135 7.472v12.455h-5.068v-24.909h5.068zM78.894 141.681v1.246H61.26c.558 4.135 4.054 6.227 7.5 6.227 5.068 0 7.602-2.491 7.602-2.491v4.982s-2.534 2.491-7.602 2.491c-7.601 0-12.669-4.982-12.669-12.455 0-7.472 5.068-12.454 11.402-12.454 6.335 0 11.402 4.982 11.402 12.454zm-11.402-7.472c-3.09 0-5.371 1.644-6.08 4.982h12.162c-.71-3.338-2.99-4.982-6.082-4.982zM103.725 141.681v1.246H86.09c.558 4.135 4.054 6.227 7.5 6.227 5.068 0 7.602-2.491 7.602-2.491v4.982s-2.534 2.491-7.602 2.491c-7.601 0-12.669-4.982-12.669-12.455 0-7.472 5.068-12.454 11.402-12.454 6.335 0 11.402 4.982 11.402 12.454zm-11.402-7.472c-3.09 0-5.371 1.644-6.08 4.982h12.161c-.709-3.338-2.99-4.982-6.08-4.982zM120.955 129.227c5.068 0 8.868 3.736 8.868 9.964v14.945h-5.067v-12.455c0-4.981-2.534-7.472-6.335-7.472-3.8 0-6.334 2.491-6.334 7.472v12.455h-5.068v-24.909h5.068v9.964c0-6.228 3.801-9.964 8.868-9.964z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.667,
    y: 165.5,
    width: 31.333,
    height: 17,
    rx: 8.5,
    fill: "#bf3122",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.333,
    y: 165.5,
    width: 31.333,
    height: 17,
    rx: 8.5,
    fill: "#de4523",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 165.5,
    width: 31.333,
    height: 17,
    rx: 8.5,
    fill: "#ef7e1a",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.667,
    y: 165.5,
    width: 31.333,
    height: 17,
    rx: 8.5,
    fill: "#f5c100",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.333,
    y: 165.5,
    width: 31.333,
    height: 17,
    rx: 8.5,
    fill: "#2ecc71",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 165.5,
    width: 31.333,
    height: 17,
    rx: 8.5,
    fill: "#1e8f4e",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.352 193.401V199s-4.182-1.401-6.969-1.401c-4.182 0-8.363 2.8-8.363 8.401 0 5.599 4.181 8.401 8.363 8.401 2.787 0 6.969-1.401 6.969-1.401v5.599S52.565 220 48.383 220c-8.363 0-13.937-5.599-13.937-14s5.574-14 13.937-14c4.182 0 6.969 1.401 6.969 1.401zM23.018 220c-4.182 0-8.364-1.401-8.364-1.401V213s4.182 1.401 8.364 1.401c2.787 0 4.182-1.401 4.182-2.8 0-1.662-2.067-2.228-4.564-2.912-3.815-1.045-8.636-2.366-8.636-8.288 0-5.599 3.444-8.401 9.02-8.401 4.182 0 8.364 1.401 8.364 1.401V199s-4.182-1.401-8.364-1.401c-2.787 0-4.181 1.401-4.181 2.8 0 1.662 2.181 2.228 4.819 2.912 4.028 1.045 9.118 2.366 9.118 8.288-.002 5.601-4.184 8.401-9.758 8.401zm62.494-14c0 8.401-5.574 14-13.938 14-8.363 0-13.937-5.599-13.937-14s5.574-14 13.937-14c8.364 0 13.938 5.599 13.938 14zm-22.299 0c0 5.599 4.182 8.401 8.364 8.401 4.181 0 8.363-2.8 8.363-8.401 0-5.599-4.182-8.401-8.363-8.401-4.182 0-8.364 2.802-8.364 8.401zm41.422-14v5.599c-5.574 0-11.15 1.401-11.15 8.401v14H87.91v-28h5.574v11.2c0-7 4.182-11.2 11.151-11.2zM130 207.401h-19.398c.613 4.649 4.459 7 8.25 7 5.574 0 8.363-2.8 8.363-2.8v5.599s-2.787 2.8-8.363 2.8c-8.363 0-13.937-5.599-13.937-14s5.574-14 12.542-14c6.969 0 12.543 5.599 12.543 14zm-19.232-4.201h13.38c-.779-3.752-3.288-5.599-6.688-5.599-3.403-.002-5.912 1.847-6.692 5.599z",
    fill: "#1d1d1b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenScoreE);
export default __webpack_public_path__ + "static/media/green-score-e.2f90fc44f5d7152d4c2527a74715472f.svg";
export { ForwardRef as ReactComponent };